<script lang="ts">
const __DsBlock = {
	icon: 'lucide:info',
	description: '$t:blocks.notice.description',
	category: 'basic',
	options: [
		{
			name: 'title',
			label: '$t:blocks.common.props.title',
		},
		{
			name: 'description',
			label: '$t:blocks.common.props.description',
		},
		{
			name: 'color',
			label: '$t:blocks.common.props.color',
			block: BuiltinBlockIds.InputSemanticColor,
		},
		{
			name: 'icon',
			label: '$t:blocks.common.props.icon',
			block: BuiltinBlockIds.InputIcon,
			nullable: true,
		},
		{
			name: 'orientation',
			label: '$t:blocks.common.props.orientation',
			type: 'enum',
			values: ['horizontal', 'vertical'],
			block: BuiltinBlockIds.InputTileRadio,
			props: {
				options: [
					{
						value: 'horizontal',
						label: '$t:blocks.notice.options.horizontal',
						icon: 'lucide:columns-2',
					},
					{
						value: 'vertical',
						label: '$t:blocks.notice.options.vertical',
						icon: 'lucide:rows-2',
					},
				],
			},
		},
	],
}
</script>
<script lang="ts" setup>
import type { SemanticColorValue } from './Input/InputSemanticColor.block.vue';
import { BuiltinBlockIds } from 'virtual:monospace-builtin-block-ids';
import { computed } from 'vue';
import { defineBlock } from '#layers/block-engine/public';
import { useTranslationUtils } from '#layers/i18n/public';

interface NoticeBlockProps {
	title?: string;
	description?: string;
	color?: SemanticColorValue;
	icon?: string;
	orientation?: 'horizontal' | 'vertical';
}

const props = withDefaults(defineProps<NoticeBlockProps>(), {
	title: '$t:blocks.notice.default_title',
	description: '$t:blocks.notice.default_description',
	color: 'info',
	orientation: 'vertical',
});

;

const { translateString } = useTranslationUtils();

const noticeProps = computed(() => ({
	...props,
	title: translateString(props.title),
	description: translateString(props.description),
}));
</script>

<template>
	<DNotice v-bind="noticeProps" />
</template>
